import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { runIndependentProductionTick } from './genericProduction';

export function runSmokehouseTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    return runIndependentProductionTick(
        settlement,
        'smokehouse',
        settlement.jobs.smokers,
        settlement.production.smokehouse.progress,
        config.production.smokehouse.ticksPerBatch,
    );
}
